import { Box, createStyles, LoadingOverlay } from '@mantine/core';
import React, { useState } from 'react';

import { useMetabaseEmbed } from '@portals/api/partners';
import { Page404 } from '@portals/framework';

export function EcommerceOverview() {
  const { classes } = useStyles();
  const metabaseEmbed = useMetabaseEmbed();

  const [isLoading, setIsLoading] = useState(true);

  if (metabaseEmbed.isFetched && !metabaseEmbed?.data?.url) {
    return (
      <Page404
        title={['Oops...', 'Something went wrong']}
        description={
          <div>
            Please try again or contact support at{' '}
            <a href="mailto:support@xyte.io">support@xyte.io</a>
          </div>
        }
      />
    );
  }
  return (
    <Box className={classes.container}>
      <LoadingOverlay visible={isLoading} />

      <iframe
        src={metabaseEmbed?.data?.url}
        width="100%"
        height="100%"
        id="metabase-dashboard"
        title="metabase"
        className={classes.iframe}
        onLoad={() => setIsLoading(false)}
      />
    </Box>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    height: '100%',
    overflow: 'hidden',
  },
  iframe: {
    border: 'none',
  },
}));
